module.exports = __webpack_public_path__ + "img/guohua.1e3927c9.png";